import { useSplitTreatment } from './useSplitTreatment';
import { SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE, SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE_COOKIE } from 'constants/split';
import { SPLIT_TRAFFIC_TYPES } from 'au-js-sdk/lib/services/split.io/constants';
import { isCard, useProduct } from '../../features/pdp';

export const useShouldSkipLoginGate = (): boolean => {
  const { treatmentStatus: skipLoginGateSplit } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE,
    SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE_COOKIE,
    SPLIT_TRAFFIC_TYPES.ANONYMOUS
  );

  const { product } = useProduct();

  const isV2Product = product.editorVersion === '2';

  const isNotCard = !isCard(product);

  return skipLoginGateSplit && isV2Product && isNotCard;
};
